/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useRef } from 'react';
import { Search } from '@atlaskit/atlassian-navigation';

import { useNavigationController } from '@/controllers';
import KeyPressPromptButton from '@/components/primitive/keypress-prompt-button';

import * as styles from './styles';

const NavSearch: React.FC = () => {
  const searchRef = useRef(null);
  const { onNavigation } = useNavigationController();

  const [value, setValue] = useState('');

  // TODO: quick search panel
  const navigateSearch = useCallback((query: string) => {
    if (!query) return;

    onNavigation({
      pathname: '/search',
      search: `query=${query}`,
    });
  }, []);

  const handleChange = useCallback((event: any) => {
    setValue(event.currentTarget.value.replace(/\#+/g, ''));
  }, []);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') navigateSearch(value);
    },
    [value]
  );

  const handleClickEnter = useCallback(() => {
    navigateSearch(value);
  }, [value]);

  const showEnterButton = value && value.length > 0;

  return (
    <div onKeyDown={handleKeyDown} ref={searchRef} css={styles.searchStyles}>
      <Search
        onClick={handleChange}
        placeholder="Search"
        tooltip="Search"
        label="Search"
        value={value}
        href="/search" // This is for responsive in small screen where only a search button appears
      />
      {showEnterButton && (
        <KeyPressPromptButton onClick={handleClickEnter} type="button">
          &#9166;
        </KeyPressPromptButton>
      )}
    </div>
  );
};

export default NavSearch;
